// extracted by mini-css-extract-plugin
export default {"history-table-container":"_history-table-container_jw9lox","history-table-links":"_history-table-links_9w9zW8","history-table":"_history-table_i7fmwK"};